import { t } from 'i18next'

/**
 * Maps error codes to translation keys
 */
const ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
  INVALID_INTEGER_FIELD:
    'rm:externalCampaignMetrics.form.error.invalidIntegerField.title',
  INVALID_CONVERSIONS_VALUE:
    'rm:externalCampaignMetrics.form.error.invalidConversionsValue.title',
  INVALID_TOTAL_SPENT:
    'rm:externalCampaignMetrics.form.error.invalidTotalSpent.title',
  MISSING_DATE: 'rm:externalCampaignMetrics.form.error.missingDate.title',
  INVALID_DATE: 'rm:externalCampaignMetrics.form.error.invalidDate.title',
  INVALID_ROW_DATE:
    'rm:externalCampaignMetrics.form.error.invalidRowDate.title',
  NON_UNIFORM_DATE:
    'rm:externalCampaignMetrics.form.error.nonUniformDate.title',
  FILE_DATE_AFTER_D1:
    'rm:externalCampaignMetrics.form.error.fileDateAfterD1.title',
  FILE_DATE_BEFORE_MIN:
    'rm:externalCampaignMetrics.form.error.fileDateBeforeMin.title',
  DUPLICATE_COMPOSITE_KEY:
    'rm:externalCampaignMetrics.form.error.duplicateCompositeKey.title',
  EMPTY_FILE: 'rm:externalCampaignMetrics.form.error.emptyFile.title',
  MISSING_REQUIRED_FIELD:
    'rm:externalCampaignMetrics.form.error.missingRequiredField.title',
  MISSING_HEADERS: 'rm:externalCampaignMetrics.form.error.missingHeaders.title',
  VALIDATION_ERRORS: 'rm:externalCampaignMetrics.form.validation_error.title',
  INTERNAL_ERROR: 'rm:externalCampaignMetrics.form.error.internalError.title',
  INVALID_FILE_DATE:
    'rm:externalCampaignMetrics.form.error.invalidFileDate.title'
}

/**
 * Gets the translation key for an error code
 */
export const getErrorTranslationKey = (code: string): string => {
  return (
    ERROR_CODE_TO_TRANSLATION_KEY[code] ||
    `rm:externalCampaignMetrics.form.error.${code.toLowerCase()}.title`
  )
}

/**
 * Gets the translated title for an error code
 */
export const getErrorTitle = (code: string): string => {
  const translationKey = getErrorTranslationKey(code)
  // @ts-expect-error: i18next t() accepts string keys but TypeScript types are strict
  return t(translationKey) as string
}
